/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */

export type DataCenter = 'US' | 'EU' | 'CA';

export interface DescopeConfig {
  projectId: string;
  flowId: string;
}

function getValue(envVars: any, key: string): string {
  return envVars?.[key] ?? (globalThis?.process?.env as any)?.[key] ?? '';
}

/**
 * Returns the correct Descope projectId and flowId for the current environment
 * and data center.
 *
 * - Non-production (staging): uses the shared NEXT_PUBLIC_DESCOPE_STAGING_PROJECT_ID /
 *   NEXT_PUBLIC_DESCOPE_STAGING_FLOW_ID pair.
 * - Production: selects credentials per data center (US / EU / CA).
 *
 * @param envVars - Pass `pageProps.publicEnvVars` in `_app.tsx` (before
 *   `setPublicEnvAsGlobal` has run). Omit in child components — the function
 *   will read from `globalThis.process.env` which is populated by then.
 */
export function getDescopeConfig(dataCenter: string, envVars?: any): DescopeConfig {
  const appEnv: string = getValue(envVars, 'NEXT_PUBLIC_APP_ENV');
  const isProduction = appEnv === 'production';

  if (!isProduction) {
    return {
      projectId: getValue(envVars, 'NEXT_PUBLIC_DESCOPE_STAGING_PROJECT_ID'),
      flowId: getValue(envVars, 'NEXT_PUBLIC_DESCOPE_STAGING_FLOW_ID') || 'resident-login',
    };
  }

  switch (dataCenter) {
    case 'EU':
      return {
        projectId: getValue(envVars, 'NEXT_PUBLIC_DESCOPE_EU_PROJECT_ID'),
        flowId: getValue(envVars, 'NEXT_PUBLIC_DESCOPE_EU_FLOW_ID') || 'resident-login',
      };
    case 'CA':
      return {
        projectId: getValue(envVars, 'NEXT_PUBLIC_DESCOPE_CA_PROJECT_ID'),
        flowId: getValue(envVars, 'NEXT_PUBLIC_DESCOPE_CA_FLOW_ID') || 'resident-login',
      };
    case 'US':
    default:
      return {
        projectId: getValue(envVars, 'NEXT_PUBLIC_DESCOPE_US_PROJECT_ID'),
        flowId: getValue(envVars, 'NEXT_PUBLIC_DESCOPE_US_FLOW_ID') || 'resident-login',
      };
  }
}
